import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'containers_stakeholder_container';

const ids = addCyPrefixToIDs(cyPrefix, {
  INPUT_FIRST_NAME: 'INPUT_FIRST_NAME',
  INPUT_LAST_NAME: 'INPUT_LAST_NAME',
  INPUT_DATE_OF_BIRTH: 'INPUT_DATE_OF_BIRTH',
  INPUT_STREET: 'INPUT_STREET',
  INPUT_POSTAL_CODE: 'INPUT_POSTAL_CODE',
  INPUT_CITY: 'INPUT_CITY',
  INPUT_REGION: 'INPUT_REGION',
  INPUT_COUNTRY: 'INPUT_COUNTRY',
  INPUT_PERSONAL_ID_QUESTION: 'INPUT_PERSONAL_ID_QUESTION',
  INPUT_PERSONAL_ID: 'INPUT_PERSONAL_ID',
  BTN_SUBMIT: 'BTN_SUBMIT',
  BTN_BACK: 'BTN_BACK',
});

/**
 * We are exporting the IDS this way to help IDEs' code completion
 */
export const CY_STAKEHOLDER_CONTAINER_IDS = ids;
